app.directive("breadcrumbs",["_$breadcrumbs","$state",function(_$breadcrumbs,$state){
   
        return {
        
        restrict:"E",
        scope:{
          
        },
        templateUrl:"/assets/js/angular/components/directives/breadcrumbs/breadcrumbs.html",
        link:function(scope){
            
            scope.breads=_$breadcrumbs.breads;
            
            scope.goTo=function(bread){
              
                if (typeof bread.state!='undefined')
                $state.go(bread.state);
            };
        }
    };
    
}]);

